import React, {createContext, useContext, useState} from 'react';

type DialogContextType<T> = {
  state: DialogState<T>;
  setState: React.Dispatch<React.SetStateAction<DialogState<T>>>;
  onClose: () => void;
};

export type DialogState<T> = (T & {type: DialogTypes}) | null;

export type DialogTypes =
  | 'demo'
  | 'html'
  | 'send-money'
  | 'flex-offer'
  | 'postpone-offer'
  | 'payment-free-month'
  | 'connect-account'
  | 'ks-ppi-anytime'
  | 'expense-protection-insurance'
  | 'activate-card'
  | 'pre-collection'
  | 'invoice-process-info'
  | 'news'
  | 'send-secure-message'
  | 'feedback'
  | 'offers-list'
  | 'offer'
  | 'digital-invoice-notification'
  | 'update-contact-information';

const DialogContext = createContext<DialogContextType<unknown> | undefined>(
  undefined,
);

export const useDialogProvider = <T,>() => {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error('useDialog must be used within an DialogContext');
  }
  return context as DialogContextType<T>;
};

export const DialogProvider: React.FC<{children: React.ReactNode}> = ({
  children,
}) => {
  const [state, setState] = useState<DialogState<unknown>>(null);
  const onClose = () => setState(null);

  return (
    <DialogContext.Provider value={{onClose, state, setState}}>
      {children}
    </DialogContext.Provider>
  );
};
